import { getSiteOrigin } from './constants';

const DEFAULT_TITLE = 'Інтернет-магазин';
const DEFAULT_DESCRIPTION = 'Інтернет-магазин інструментів та обладнання. Каталог товарів, зручне замовлення та доставка по Україні.';

const setMetaName = (name, content) => {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const removeMetaName = (name) => {
  document.querySelector(`meta[name="${name}"]`)?.remove();
};

const setMetaProperty = (property, content) => {
  if (!content) return;
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('property', property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const setCanonical = (href) => {
  if (!href) return;
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

const removeCanonical = () => {
  document.querySelector('link[rel="canonical"]')?.remove();
};

const absoluteUrl = (path) => {
  if (!path) return getSiteOrigin() || '';
  if (path.startsWith('http')) return path;
  const origin = getSiteOrigin();
  return `${origin}${path.startsWith('/') ? path : `/${path}`}`;
};

/** SEO для головної сторінки. */
export const applyHomeSeo = () => {
  document.title = DEFAULT_TITLE;
  setMetaName('description', DEFAULT_DESCRIPTION);
  setMetaName('robots', 'index, follow');
  setCanonical(absoluteUrl('/'));
  setMetaProperty('og:title', DEFAULT_TITLE);
  setMetaProperty('og:description', DEFAULT_DESCRIPTION);
  setMetaProperty('og:type', 'website');
  setMetaProperty('og:url', absoluteUrl('/'));
  setMetaProperty('og:locale', 'uk_UA');
};

/** Службові сторінки — не індексувати. */
export const applyNoIndexSeo = (title = DEFAULT_TITLE) => {
  document.title = title;
  setMetaName('robots', 'noindex, nofollow');
  removeMetaName('description');
  removeCanonical();
};

/** Повний набір мета-тегів для товару / категорії. */
export const applyPageSeo = ({
  title,
  description,
  keywords,
  canonical,
  ogImage,
  ogType = 'website',
  robots = 'index, follow',
}) => {
  if (title) {
    document.title = title;
  }

  if (description) {
    setMetaName('description', description);
  } else {
    removeMetaName('description');
  }

  if (keywords) {
    setMetaName('keywords', keywords);
  } else {
    removeMetaName('keywords');
  }

  setMetaName('robots', robots);

  if (canonical) {
    setCanonical(absoluteUrl(canonical));
  } else {
    removeCanonical();
  }

  setMetaProperty('og:title', title || DEFAULT_TITLE);
  setMetaProperty('og:description', description || DEFAULT_DESCRIPTION);
  setMetaProperty('og:type', ogType);
  setMetaProperty('og:url', canonical ? absoluteUrl(canonical) : getSiteOrigin());
  setMetaProperty('og:locale', 'uk_UA');
  setMetaProperty('og:site_name', DEFAULT_TITLE);

  if (ogImage) {
    setMetaProperty('og:image', absoluteUrl(ogImage));
    setMetaName('twitter:card', 'summary_large_image');
    setMetaName('twitter:image', absoluteUrl(ogImage));
  }

  setMetaName('twitter:title', title || DEFAULT_TITLE);
  setMetaName('twitter:description', description || DEFAULT_DESCRIPTION);
};

export const resetPageSeo = () => {
  document.title = DEFAULT_TITLE;
  removeMetaName('description');
  removeMetaName('keywords');
  removeMetaName('robots');
  removeCanonical();
};
